import React, { useMemo } from "react";
import { Bar, ComposedChart, XAxis, ResponsiveContainer } from "recharts";
import GraphLoader from "../../components/GraphLoader";

const PvsystAmbientTemp = ({
  loading,
  pvsystActualTemp,
  setProgressValueAnimate,
  progressValueAnimate,
}) => {
  const filteredData = useMemo(() => {
    if (pvsystActualTemp?.length > 0) {
      const pvsystTempLen = pvsystActualTemp?.reduce(
        (acc, curr) => acc + (curr?.["PVsyst Ambient Temp"] ? 1 : 0),
        0
      );
      const actualTempLen = pvsystActualTemp?.reduce(
        (acc, curr) => acc + (curr?.["Actual Ambient Temp"] ? 1 : 0),
        0
      );
      return {
        pvsystTemp:
          pvsystTempLen > 0
            ? Number(
                Number(
                  pvsystActualTemp?.reduce(
                    (acc, curr) => acc + (curr?.["PVsyst Ambient Temp"] || 0),
                    0
                  ) / pvsystTempLen
                ).toFixed(2)
              )
            : 0,
        actualTemp:
          actualTempLen > 0
            ? Number(
                Number(
                  pvsystActualTemp?.reduce(
                    (acc, curr) => acc + (curr?.["Actual Ambient Temp"] || 0),
                    0
                  ) / actualTempLen
                ).toFixed(2)
              )
            : 0,
      };
    }
    return {
      actualTemp: null,
      pvsystTemp: null,
    };
  }, [pvsystActualTemp]);

 
  return (
    <div className="detail_overview_1">
      {loading ? (
        <div style={{ height: "100%", width: "100%" }}>
          <GraphLoader />
        </div>
      ) : !pvsystActualTemp || pvsystActualTemp?.length == 0 ? (
        <div style={{ height: "100%", width: "100%", fontSize: "2vmin" }}>
          <p>PVsyst Ambient Temp (℃) and Actual Ambient Temp (℃)</p>
          <p>Data Not Available</p>
        </div>
      ) : (
        <>
          <div>
            <span style={{position:"absolute",fontSize:"0.8rem", top: 0, left: 0,right:0 }}>{pvsystActualTemp?.[0]?.Date} to {pvsystActualTemp?.[pvsystActualTemp?.length-1]?.Date}</span>

            <div>
              <div>
                <progress
                  className="progress_4"
                  style={{
                    accentColor: "green",
                    borderRadius: "14px",
                    border: progressValueAnimate.progress7
                      ? "3px solid red"
                      : "none",
                  }}
                  value={filteredData.pvsystTemp}
                  max={100}
                />
              </div>
              <div>
                <span>PVsyst Ambient Temp (℃)</span>
                <span
                  style={{
                    position: "absolute",
                    left: `${filteredData.pvsystTemp - 3}%`,
                    bottom: "60%",
                  }}
                >
                  <i class="fa-solid fa-caret-up"></i>
                </span>
                <span>{filteredData.pvsystTemp || "N/A"}</span>
              </div>
            </div>
            <div>
              <div>
                <progress
                  className="progress_5"
                  style={{
                    accentColor: "green",
                    borderRadius: "14px",
                    border: progressValueAnimate.progress8
                      ? "3px solid black"
                      : "none",
                  }}
                  value={filteredData.actualTemp}
                  max={100}
                />
              </div>
              <div>
                <span>Actual Ambient Temp (℃)</span>
                {/* <span style={{fontSize:"1.2rem"}}><ArrowDropUpIcon  /></span> */}
                <span
                  style={{
                    position: "absolute",
                    left: `${filteredData.actualTemp - 3}%`,
                    bottom: "60%",
                  }}
                >
                  <i class="fa-solid fa-caret-up"></i>
                </span>
                <span>{filteredData.actualTemp || "N/A"}</span>
              </div>
            </div>
            <div>
              <div>
                <progress
                  className="progress_3"
                  style={{ accentColor: "blue" }}
                  value={Math.abs(
                    filteredData.actualTemp && filteredData.pvsystTemp
                      ? ((filteredData.actualTemp - filteredData.pvsystTemp) *
                          100) /
                          filteredData.pvsystTemp
                      : 0
                  )}
                  max="100"
                />
              </div>
              <div>
                <span>Excess(+)/ShortFall(-) (%)</span>
                {/* <span style={{fontSize:"1.2rem"}}><ArrowDropUpIcon  /></span> */}
                <span
                  style={{
                    position: "absolute",
                    left: `${
                      Math.abs(
                        filteredData.actualTemp && filteredData.pvsystTemp
                          ? ((filteredData.actualTemp -
                              filteredData.pvsystTemp) *
                              100) /
                              filteredData.pvsystTemp
                          : 0
                      ) - 3 || 0
                    }%`,
                    bottom: "60%",
                  }}
                >
                  <i class="fa-solid fa-caret-up"></i>
                </span>
                <span>
                  {filteredData.actualTemp & filteredData.pvsystTemp
                    ? (
                        ((filteredData.actualTemp - filteredData.pvsystTemp) *
                          100) /
                        filteredData.pvsystTemp
                      ).toFixed(2)
                    : "N/A"}
                </span>
              </div>
            </div>
          </div>
          <div>
            <div>
              <span>{filteredData.pvsystTemp || "N/A"}</span>
              <span>PVsyst Ambient Temp (℃)</span>
              <div style={{ width: "80%", height: 30 }}>
                <ResponsiveContainer>
                  <ComposedChart
                    margin={{
                      top: 0,
                      bottom: 0,
                      left: 0,
                      right: 0,
                    }}
                    data={pvsystActualTemp || []}
                  >
                    <XAxis dataKey="name" hide />
                    {/* <Tooltip content={<CustomizeTootip active={false} payload={[]} label={""} TooltipValues={["PVsyst GHI"]} />} /> */}
                    <Bar
                      barSize={4}
                      radius={14}
                      dataKey="PVsyst Ambient Temp"
                      fill="#8884d8"
                    />
                  </ComposedChart>
                </ResponsiveContainer>
              </div>
              <span
                className="progress_button_1"
                onMouseEnter={() =>
                  setProgressValueAnimate({
                    ...progressValueAnimate,
                    progress7: true,
                  })
                }
                onMouseOut={() =>
                  setProgressValueAnimate({
                    ...progressValueAnimate,
                    progress7: false,
                  })
                }
              >
                View
              </span>
            </div>
            <div>
              <span>{filteredData.actualTemp || "N/A"}</span>
              <span>Actual Ambient Temp (℃) </span>
              <div style={{ width: "80%", height: 30 }}>
                <ResponsiveContainer>
                  <ComposedChart
                    margin={{
                      top: 0,
                      bottom: 0,
                      left: 0,
                      right: 0,
                    }}
                    data={pvsystActualTemp || []}
                  >
                    <XAxis dataKey="name" hide />
                    {/* <Tooltip content={<CustomizeTootip active={false} payload={[]} label={""} TooltipValues={["Actual GHI"]} />} /> */}
                    <Bar
                      barSize={4}
                      radius={14}
                      dataKey="Actual Ambient Temp"
                      fill="#8884d8"
                    />
                  </ComposedChart>
                </ResponsiveContainer>
              </div>
              <span
                onMouseEnter={() =>
                  setProgressValueAnimate({
                    ...progressValueAnimate,
                    progress8: true,
                  })
                }
                onMouseOut={() =>
                  setProgressValueAnimate({
                    ...progressValueAnimate,
                    progress8: false,
                  })
                }
                className="progress_button_2"
              >
                View
              </span>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default PvsystAmbientTemp;
